'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var PropTypes = require('prop-types');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var _exp = function _exp() {
  return function (_ref) {
    var margin = _ref.margin;
    return margin !== null && margin !== void 0 ? margin : '0px 0px var(--space-xy-small-rem) 0px';
  };
};
var StyledProductLabel = /*#__PURE__*/react.styled('div')({
  name: "StyledProductLabel",
  "class": "s1le76a4",
  propsAsIs: false,
  vars: {
    "s1le76a4-0": [_exp()]
  }
});

var propTypes = {
  /** The text for the product label. */
  text: PropTypes__default["default"].string.isRequired,
  /** The margin to be applied to the product label for positioning */
  margin: PropTypes__default["default"].string
};
var ProductLabel = function ProductLabel(_ref) {
  var text = _ref.text,
    margin = _ref.margin;
  return /*#__PURE__*/jsxRuntime.jsx(StyledProductLabel, {
    margin: margin,
    children: text
  });
};
ProductLabel.propTypes = propTypes;

exports["default"] = ProductLabel;
